import React, { memo } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { ListHeader } from '@redlink/components/muscles';
import { ListContainerPlaceholder } from '@redlink/components/molecules';
import { LoadingContainer } from '../atoms';

export const ListContainer = memo(
  ({
    children,
    containerContainerStyle,
    scrollable,
    placeholder,
    data = [],
    actions,
    isFetching,
    ...rest
  }) => {
    const { styles } = useStyle();
    const hasItems = data.length > 0;
    const fetchingForTheFirstTime = isFetching && !hasItems;

    return fetchingForTheFirstTime ? (
      <LoadingContainer isBusy hasOverlay={false} />
    ) : hasItems || !placeholder ? (
      <>
        <ListHeader {...{ actions }} {...rest} />
        <View
          style={[
            containerContainerStyle,
            scrollable && styles.scrollableContent,
          ]}
        >
          {children}
        </View>
      </>
    ) : (
      <ListContainerPlaceholder {...{ actions }} {...placeholder} />
    );
  }
);

const useStyle = createUseStyle(({ colors, size }) => ({
  scrollableContent: {
    flex: 1,
  },
}));
